import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TabBar, SkeletonHero, SkeletonCard, SectionError } from '../components/intel/ui';
import LeagueHeader from '../components/intel/LeagueHeader';
import LeagueOverview from '../components/intel/LeagueOverview';
import LeagueTeams from '../components/intel/LeagueTeams';
import LeagueMatchweeks from '../components/intel/LeagueMatchweeks';
import LeagueTopScorers from '../components/intel/LeagueTopScorers';
import StandingsTable from '../components/intel/StandingsTable';

const TABS = ['Overview', 'Standings', 'Teams', 'Matchweeks', 'Top Scorers'];
const EP = (id) => `https://stats.interaios.com/api/v1/leagues-sportsmonk/get-league/${id}`;

export default function LeagueProfile() {
  const { leagueId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState('Overview');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true); setError(null);
      try {
        const res = await fetch(EP(leagueId));
        if (!res.ok) throw new Error('League data unavailable');
        const json = await res.json();
        if (!json?.data?.detail && !json?.data?.standings && !json?.data?.teams) throw new Error('League data unavailable');
        if (!cancelled) setData(json.data);
      } catch (e) { if (!cancelled) setError(e.message); }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, [leagueId]);

  return (
    <div className="intel">
      {loading && (<><SkeletonHero />{[1, 2, 3].map((i) => <SkeletonCard key={i} />)}</>)}
      {error && <SectionError message={error} onRetry={() => navigate(0)} />}
      {data && !loading && (
        <>
          <LeagueHeader data={data} />
          <div className="i-card p-0 mb-4">
            <TabBar tabs={TABS} active={tab} onChange={setTab} />
            <div className="p-4">
              {tab === 'Overview' && <LeagueOverview data={data} />}
              {tab === 'Standings' && (
                data?.standings?.length
                  ? <StandingsTable rows={data.standings} />
                  : <p className="i-dim text-sm">No standings available.</p>
              )}
              {tab === 'Teams' && <LeagueTeams data={data} />}
              {tab === 'Matchweeks' && <LeagueMatchweeks data={data} />}
              {tab === 'Top Scorers' && <LeagueTopScorers data={data} />}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
